<template>
    <div
         :class="{'t_cell': true, 't_cell-open': ['open', 'openDetails'].includes(columnKey), 't_cell-attachments': ['attachments', 'openWeatherReport', 'downloadReport', 'downloadReportConfirmed'].includes(columnKey)}"
         :style="column.style">
        <div class="t_cell_content">
            <a
                :href="column.value.url || ''"
                v-if="['open', 'openDetails'].includes(columnKey)">
                <i class="fa fa-eye"></i>
            </a>
            <a v-else-if="['deleteAction', 'actions'].includes(columnKey)"
               @click="deleteItem(column)">
                <svg
                    v-if="showDelete"
                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.00293 20C5.00293 21.103 5.89993 22 7.00293 22H17.0029C18.1059 22 19.0029 21.103 19.0029 20V8H21.0029V6H17.0029V4C17.0029 2.897 16.1059 2 15.0029 2H9.00293C7.89993 2 7.00293 2.897 7.00293 4V6H3.00293V8H5.00293V20ZM9.00293 4H15.0029V6H9.00293V4ZM8.00293 8H17.0029L17.0039 20H7.00293V8H8.00293Z" fill="#2C2A44"/>
                <path d="M9.00293 10H11.0029V18H9.00293V10ZM13.0029 10H15.0029V18H13.0029V10Z" fill="#2C2A44"/>
            </svg>
            </a>
            <span v-else-if="column.formatter === 'link'">
                <a v-if="column.value.value" :href="column.value.value" target="_blank" v-text="column.value.title"></a>
                <span v-else v-text="column.value"></span>
            </span>
            <span v-else-if="columnKey === 'has_shape'">
                <application-field-borders :geo="JSON.parse(column.value)" :draw-type="2" inline-template>
                    <canvas width="30" height="30" ref="canvas"></canvas>
                </application-field-borders>
            </span>
            <select-checkbox-component v-else-if="columnKey === 'selectCheckbox'"
                                       :value="column.value"
                                       :isChecked="checked"
                                       @toggle="toggleSelect" />

            <div  v-else-if="columnKey === 'attachments'">
                <a :href="column.value.url" v-if="isObject(column.value) && column.value.count > 0">
                    <i class="fa fa-paperclip"></i>
                </a>
                <a v-else-if="!isObject(column.value)">
                    <i class="fa fa-paperclip"></i>
                </a>
            </div>

            <span v-else-if="['openWeatherReport'].includes(columnKey)">
                <i @click.prevent="openWeatherReport(column.value)" v-if="column.value && column.value !== 0" class="fas fa-chart-area"></i>
            </span>
            <span v-else-if="['downloadReport', 'downloadReportConfirmed'].includes(columnKey)">
                <i v-if="column.value && column.value !== 0" @click="downloadPayoutReport(column.value)" class="far fa-file-alt"></i>
            </span>
            <span v-else v-html="column.value"></span>
        </div>
    </div>
</template>

<script>
import SelectCheckboxComponent from "./SelectCheckboxComponent";

export default {
    name: "RowComponent",

    components: {SelectCheckboxComponent},

    props: ['column', 'columnKey', 'checked', 'showDelete'],

    mounted() {
        if (!this.column.url) {
            this.column.url = null
        }
    },

    methods: {
        toggleSelect(id, status) {
            this.$emit('toggle', id, status);
        },

        openWeatherReport(id) {
            Livewire.emit('openApplicationWeather', id);
        },

        downloadPayoutReport(id) {
            Livewire.emit('downloadPayoutReport', id);
        },

        isObject(variable) {
            return typeof variable === 'object';
        },

        deleteItem() {
            this.$emit('deleteItem', this.column.value)
        }
    }
}
</script>
